import { render, staticRenderFns } from "./giftcard-cp-price-dialog-filter.vue?vue&type=template&id=6361d70c"
import script from "./giftcard-cp-price-dialog-filter.vue?vue&type=script&lang=js"
export * from "./giftcard-cp-price-dialog-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports